module.exports = __webpack_public_path__ + "img/ws.4e23829b.jpg";